module.exports = __webpack_public_path__ + "img/fondo-socios.8c8a8970.jpg";